/** Unified Connections framework — barrel re-exports.
 *
 *  Side-effect: importing this module registers all three
 *  connection kinds (snap, offset, mirror) with the global
 *  `CONNECTIONS` registry. Modules that consume the registry
 *  (LayersPanel, PropertiesPanel, Scene, app.ts commit pipeline)
 *  should import from here (not from `./Connection` directly) so
 *  the side-effects run.
 *
 *  Order of registration matches the desired pipeline / display
 *  order:
 *    snap (0) — pruning only, no commit-time derive
 *    offset (1) — derive runs before mirror so mirror-of-offset
 *                 reads the freshly-derived offset pathData
 *    mirror (2) — runs last; reads upstream geometry
 */

import { registerConnection } from "./Connection";
import { snapConnection } from "./snapConnection";
import { offsetConnection } from "./offsetConnection";
import { mirrorConnection } from "./mirrorConnection";
import { traceConnection } from "./traceConnection";

registerConnection(snapConnection);
registerConnection(offsetConnection);
registerConnection(mirrorConnection);
// Trace (piece ← construction lines). No commit-time derive; surfaces chips +
// Connections rows on the construction-line side.
registerConnection(traceConnection);

export * from "./Connection";
export { snapConnection } from "./snapConnection";
export { offsetConnection } from "./offsetConnection";
export {
  traceConnection,
  traceConnectionKey,
  detachTracedPiece,
  partTraceChipSpec,
  partTraceRowSpecs,
  subTraceChipSpec,
  subTraceRowSpecs,
  detachTracedSub,
  TRACE_CHIP_ICON_SVG,
  type TracedSub,
} from "./traceConnection";
// Notes (#157) — a note's "points at" link. Spec builders only: see the module
// header for why this one is deliberately not registered.
export {
  noteChipSpecs,
  noteConnectionKey,
  noteRowSpecs,
  notedTargets,
  notesForPiece,
  partNoteChipSpecs,
  targetNoteChipSpecs,
  unpinNote,
  NOTE_CHIP_ICON_SVG,
} from "./noteConnection";
export {
  mirrorConnection,
  reachableMirrors,
  resolveMirrorRoot,
  detectMirrorCycles,
  inverseMirrorVertexEdit,
  applyMirrorDelta,
  canBidirectionallyEditMirror,
  walkMirrorChainToSource,
  routeMirrorRotationToSource,
} from "./mirrorConnection";
